<template>
  <div
    v-tooltip="$t('COMBINATION.SEND_SMS')"
    class="modal-icon"
    @click="emit('modal:show', $event, CommunicationType.sms)"
  >
    <div class="flex h-full items-center justify-center">
      <icon-base :icon="IconMessage" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CommunicationType } from "@/enums/communicationLogs";

import IconMessage from "@/components/icons/IconMessage.vue";

const emit = defineEmits<{
  "modal:show": [MouseEvent, CommunicationType];
}>();
</script>
